import { RootState } from '..';

export const selectUiState = (state: RootState) => state.uiReducer;

export const selectTranslate = (state: RootState) => state.uiReducer.translate;

export const selectPageMode = (state: RootState) => state.uiReducer.pageMode;
